module.exports = __webpack_public_path__ + "img/云产品云储存.5a215792.jpg";